
import { getQuestionList, getCommerceContact } from '~/api/about/index.js'
import AboutSubHeader from '~/components/about/sub-header.vue'
import AboutLinkBtnWrap from '~/components/about/link-btn-wrap.vue'
const pageCount = 9
export default {
  name: 'Zxzx',
  components: {
    AboutSubHeader,
    AboutLinkBtnWrap,
  },
  layout: 'template-page',
  data() {
    return {
      questionList: [], // 问题列表
      page: 1,
      totalPage: Object.freeze(1),
      cooperateList: [
        {
          title: '市场合作',
          subTitle: '问卷网各类合作，有意者请联系',
          image: require('~/assets/image/about/about-market.png'),
          email: 'lx.tuo@wenjuan.com',
          phone: '133 0167 9863',
          name: '拓女士',
          qqNumber: '',
        },
        {
          title: '商务合作',
          subTitle: '欢迎有流量的网站、APP加入爱调研调研联盟。按照完成的有效样本数结算，付款及时。',
          image: require('~/assets/image/about/about-business.png'),
          email: 'cui.wang@idiaoyan.com',
          phone: '185 2108 0234',
          name: '王先生',
          qqNumber: '1762345858',
        },
      ],
      chatList: [
        {
          title: '在线反馈',
          subTitle: '1个工作日内可得到回复',
          image: require('~/assets/image/about/about-feedback.png'),
          isBtn: true,
          label: '提交反馈',
          icon: '',
          linkUrl: 'https://www.wenjuan.com/s/UZBZJv0YwSd/#',
          type: 'feedback',
        },
        {
          title: '在线咨询',
          subTitle: '',
          image: require('~/assets/image/about/about-chat.png'),
          isBtn: true,
          label: '咨询客服',
          icon: '',
          linkUrl: '',
          type: 'chat',
        },
        {
          title: '电话咨询',
          subTitle: '',
          image: require('~/assets/image/about/about-phone.png'),
          isBtn: false,
          label: '4006-700-778',
          icon: '',
          linkUrl: '',
          type: 'phone',
        },
      ],
    }
  },
  fetchOnServer: false,
  async fetch() {
    try {
      await Promise.all([this.getQuestionList(), this.getCommerceContact()])
    } catch (error) {
      console.log('fetch error: ', error)
    }
  },
  head() {
    return {
      title: '咨询反馈_问卷网',
    }
  },
  //   mounted() {
  // this.initMain()
  //   },
  computed: {
    onePageQuestion() {
      return this.questionList.slice((this.page - 1) * pageCount, this.page * pageCount)
    },
  },
  methods: {
    // initMain() {
    //   this.getQuestionList()
    //   this.getCommerceContact()
    // },
    //  获取帮助中心问题列表
    async getQuestionList() {
      try {
        const { data } = await getQuestionList({ page: 1, page_size: 99 })
        const { frequent = [] } = data || {}
        this.questionList = frequent
        this.totalPage = Math.ceil(frequent.length / pageCount)
        console.log(this.totalPage, frequent.length / pageCount)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    //  获取市场合作联系人
    async getCommerceContact() {
      try {
        const { data } = await getCommerceContact()
        console.log(data)
        const { name = '', email = '', mobile = '' } = data[0] || {}
        const phoneArr = mobile.trim().split('')
        phoneArr.splice(3, 0, ' ')
        phoneArr.splice(8, 0, ' ')
        Object.assign(this.cooperateList[0], {
          name,
          email,
          phone: phoneArr.join(''),
        })
      } catch (error) {
        return Promise.reject(error)
      }
    },
    refreshQuestion() {
      console.log('refreshQuestion', this.page, this.totalPage)
      this.page = this.page + 1 > this.totalPage ? 1 : this.page + 1
    },
    // 按钮类型判断处理方式
    jumpTo(type, url) {
      if (type === 'chat') {
        window.ysf && window.open(window.ysf('url'))
      } else {
        this.jump(url)
      }
    },
    // 跳转路由
    jump(url, query) {
      if (!url) {
        return
      }
      this.$open(url, query)
    },
  },
}
